import { useState } from "react";

//components
import TemplateList from "./components/TemplateList";
import AddTemplate from "./components/AddTemplate";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";


const Template = () => {
    const [showForm, setShowForm] = useState(false);
    const [reloadList, setReloadList] = useState(false)

    const handleTemplateCreated = ()=>{
        setReloadList(prevState => !prevState);
        setShowForm(false);
    }
    return (
        <div className="projects-container">
            <h1>Gestione Template</h1>
            <div className="template__Wrapper">
                <TemplateList reloadList={reloadList}/>
                <Button onClick={() => setShowForm(true)} style={{marginBottom:'2rem'}}> 
                    Crea nuovo Template
                </Button>
                <Dialog
                    header="Crea nuovo Template"
                    visible={showForm}
                    style={{ width: '50vw' }} 
                    modal
                    onHide={() => setShowForm(false)}
                >
                    <AddTemplate onTemplateCreated={handleTemplateCreated}  /> 
                </Dialog>
            </div>
        </div>
    );
}

export default Template;